import { TextAreaField } from './Fields'
import { RecoveryCertificateQuery_recoveryCertificates } from './__generated__/RecoveryCertificateQuery'

export const CertificateNotes = ({
  recoveryCertificate,
  edit,
}: {
  recoveryCertificate: RecoveryCertificateQuery_recoveryCertificates
  edit: boolean
}) => (
  <article className="message">
    <div className="message-header">
      <p className="has-text-light">Notes</p>
    </div>
    <div className="message-body  is-size-7 p-0">
      <TextAreaField value={recoveryCertificate?.notes} name="notes" edit={edit} />
    </div>
  </article>
)

export default CertificateNotes
